import {api} from '../components/Base/App';

export default {
    publishObject(propertyId) {
        return api({
            method: 'post',
            url: `/rest/gw/site/my/property/${propertyId}/publish`
        });
    },

    getAirbnbExports(propertyId) {
        return api({
            method: 'get',
            url: `/rest/gw/site/my/property/${propertyId}/airbnb-export`
        });
    },

    updateAirbnbExport(propertyId, exportId, synchronizationCategory) {
        return api({
            method: 'put',
            url: `/rest/gw/site/my/property/${propertyId}/airbnb-export/${exportId}/${synchronizationCategory}`
        });
    },

    addAirbnbExport(propertyId, userId) {
        return api({
            method: 'post',
            url: `/rest/gw/site/my/property/${propertyId}/airbnb-export`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                userId
            }
        });
    },
    addAirbnbExportExisting(propertyId, userId, listingId, synchronizationCategory) {
        return api({
            method: 'post',
            url: `/rest/gw/site/my/property/${propertyId}/airbnb-export-sync`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                userId,
                listingId,
                synchronizationCategory
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/PersonalProperty.js